import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from '@riise/shared/components/layout/header/header.component';
import { SidebarComponent } from '@riise/shared/components/layout/sidebar/sidebar.component';
import { FooterComponent } from '@riise/shared/components/layout/footer/footer.component';
import { TabToTopComponent } from '@riise/shared/components/tab-to-top/tab-to-top.component';
import { Component, HostListener, OnInit, inject } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { BehaviorSubject, interval, Subscription } from 'rxjs';
import { SwitcherService } from '@riise/core/services/switcher/switcher.service';
import { UserData } from '@riise/shared/utils/constants/users';

import { TranslateService } from '@ngx-translate/core';
import { OTHERS } from '@riise/shared/utils/constants/others';
import { MaintenanceService } from '@riise/core/services/maintenance/maintenance.service';
import { NetworkService } from '@riise/core/services/network/network.service';
import { AnnouncementsService } from '@riise/core/services/announcements/announcements.service';
import { MaintenanceComponent } from '@riise/shared/components/maintenance/maintenance.component';
import { SnackbarComponent } from '@riise/shared/components/snackbar/snackbar.component';
import { LoaderComponent } from '@riise/shared/components/loader/loader.component';
import { WhatsNewComponent } from '@riise/shared/components/whats-new/whats-new.component';


@Component({
  selector: 'app-content',

    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        NgSelectModule,
        NgScrollbarModule,
        NgbModule,
        SnackbarComponent,
        LoaderComponent,
        HeaderComponent,
        SidebarComponent,
        FooterComponent,
        TabToTopComponent,
        MaintenanceComponent,
        // WhatsNewComponent
    ],
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss']
})
export class ContentComponent implements OnInit {

  private router = inject(Router);
  private SwitcherService = inject(SwitcherService);
  private userData = inject(UserData);


  private translateService = inject(TranslateService);
  private maintenanceService = inject(MaintenanceService);
  private networkService = inject(NetworkService);
  private announcementsService = inject(AnnouncementsService);



  protected showSnackbar: boolean = false;
  protected message: string = '';
  protected snackbarClass: string = '';
  private snackbarSubscription: Subscription;
  private messageSubscription: Subscription;
  private snackbarClassSubscription: Subscription;
  space: any = this.userData?.space;
  SPACES_CLIENTS = OTHERS.SPACES_CLIENTS
  SPACES_PROVIDERS = OTHERS.SPACES_PROVIDERS
  isLoading: boolean | undefined;
  SPACES: String[] = ["1", "2", "7", "8"];
  isInMaintenanceMode: any;
  scrolled: boolean = false;
  showAnnouncement: boolean = false;
  showWhatsNew: boolean = true;

  /** Inserted by Angular inject() migration for backwards compatibility */




  constructor() {
      const router = this.router;


      router.events.forEach((event) => {
        if (event instanceof RouteConfigLoadStart) {
          this.isLoading = true;
        } else if (event instanceof RouteConfigLoadEnd) {
          this.isLoading = false;
        }
      });


      this.snackbarSubscription = this.networkService.showSnackbar$.subscribe(show => {
        setTimeout(() => {
          this.showSnackbar = show;
        });
      });

      this.messageSubscription = this.networkService.message$.subscribe(msg => {
        setTimeout(() => {
          this.message = msg;
        });
      });

      this.snackbarClassSubscription = this.networkService.snackbarClass$.subscribe(className => {
        setTimeout(() => {
          this.snackbarClass = className;
        });
      });

      this.maintenanceService.isInMaintenanceMode$.subscribe(value => {
        setTimeout(() => {
          this.isInMaintenanceMode = value;
        });
      });

  }


  ngOnInit(): void {}


  toggleSwitcherBody() {
    this.SwitcherService.emitChange(false);
  }


  retry() {
    window.location.reload()
  }


  @HostListener('window:scroll', [])
  onWindowScroll() {
      this.scrolled = window.scrollY > 74;
  }



  ngOnDestroy(): void {
    this.snackbarSubscription.unsubscribe();
    this.messageSubscription.unsubscribe();
    this.snackbarClassSubscription.unsubscribe();
  }

  triggerAnnouncement() {
    this.showAnnouncement = true;
  }

  closeWhatsNew() {
    this.showWhatsNew = false;
  }
}
